export const common = {
  // TODO: Add common translations here
};
